'use strict';

var promisify = require('promisify-es6');

var _require = require('iso-url'),
    URL = _require.URL;

var _require2 = require('iso-stream-http'),
    getRequest = _require2.getRequest;

var SendOneFile = require('../utils/send-one-file-multiple-results');

var FileResultStreamConverter = require('../utils/file-result-stream-converter');

module.exports = function (send) {
  var sendOneFile = SendOneFile(send, 'add');
  return promisify(function (url, opts, callback) {
    if (typeof opts === 'function' && callback === undefined) {
      callback = opts;
      opts = {};
    } // opts is the real callback --
    // 'callback' is being injected by promisify


    if (typeof opts === 'function' && typeof callback === 'function') {
      callback = opts;
      opts = {};
    }

    if (!validUrl(url)) {
      return callback(new Error('"url" param must be an http(s) url'));
    }

    requestWithRedirect(url, opts, sendOneFile, callback);
  });
};

var validUrl = function validUrl(url) {
  return typeof url === 'string' && url.startsWith('http');
};

var requestWithRedirect = function requestWithRedirect(url, opts, sendOneFile, callback) {
  var parsedUrl = new URL(url);
  var req = getRequest(parsedUrl, function (res) {
    if (res.statusCode >= 400) {
      return callback(new Error("Failed to download with ".concat(res.statusCode)));
    }

    var redirection = res.headers.location;

    if (res.statusCode >= 300 && res.statusCode < 400 && redirection) {
      if (!validUrl(redirection)) {
        return callback(new Error('redirection url must be an http(s) url'));
      }

      requestWithRedirect(redirection, opts, sendOneFile, callback);
    } else {
      var requestOpts = {
        qs: opts,
        converter: FileResultStreamConverter
      };
      var fileName = decodeURIComponent(parsedUrl.pathname.split('/').pop());
      sendOneFile({
        content: res,
        path: fileName
      }, requestOpts, callback);
    }
  });
  req.once('error', callback);
  req.end();
};